import { dateUtils } from 'shared_DEPRECATED/utils/date';

import { useSprintsQuery } from 'features/sprint/hooks';

import { PlanningSprintModel } from '../../planning/Sprint';

type TParams = {
  sprintChallengesCount: number;
  sprintTitle: string;
};

export const useIsDraftSprintReadyToStart = ({
  sprintChallengesCount,
  sprintTitle,
}: TParams) => {
  const { data: sprints } = useSprintsQuery<PlanningSprintModel[]>();

  const hasActiveSprint = sprints && sprints.length > 0 && sprints[0].isActive;

  const isSprintActiveAndFinished =
    hasActiveSprint && dateUtils.isCurrentDateAfterDate(sprints[0].endDate);

  return (
    (isSprintActiveAndFinished || !hasActiveSprint) &&
    sprintChallengesCount > 0 &&
    sprintTitle
  );
};
